export default [
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NC-01',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NC-02',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NC-03',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NC-04',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NC-05',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'add . at the end of the sentence',
        error_id: 'NC-06',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
]